import { CreateChatTypeDto } from '../services/dto';
import { CreatedChat } from '../entities';

export const mapCreateChatDtoToEntity = (dto: CreateChatTypeDto): CreatedChat => ({
  chatId: dto.chat_id,
  expertId: dto.expert_id,
});
